import { action, makeObservable, observable } from 'mobx';

import { storeFactory } from 'src/utils/store';

import { FoodGeneratorsApi } from 'src/api/foodGenerators';
import { AccountEFGStore } from '../EFG/store';
import { ItemType } from 'src/types';
import { FoodGeneratorDetailsResponse } from 'src/api/api-types/food-generators';
import { ApiReq, emptyValue } from 'src/api';
import { GridRowId } from '@mui/x-data-grid-pro';
import { EfrDetailsItem } from 'src/models/edible-food/efr-details-item';
import { EfrDetailsType } from 'src/api/api-types/foods';
import { EfrModel } from 'src/models/edible-food/efr-model';

class AccountEFRStore {
  api = new FoodGeneratorsApi({ prefix: '' });
  @observable accountEFGStore: AccountEFGStore;
  @observable efrModel = new EfrModel();
  @observable accountsId?: number;
  @observable isLinking: boolean = false;
  @observable isCreation = false;
  @observable deleteFoodModal: boolean = false;

  @observable.ref modificationFood?: EfrDetailsItem;

  @observable.ref updateReq: ApiReq<FoodGeneratorDetailsResponse> = emptyValue;

  constructor() {
    makeObservable(this);
    this.accountEFGStore = new AccountEFGStore();
    this.efrModel = new EfrModel();
  }

  @action addEFR = () => {
    this.isLinking = !this.isLinking;
  };

  @action resetIsLinking = () => this.isLinking = false;

  @action editEFR = () => {
    this.efrModel.editEFRAction(Number(this.efrModel.selectedFoods[0]));
    this.removeSelectedFoods();
  };

  @action setAccountId = (value: number) => {
    this.accountsId = value;
  };

  @action deleteAssignFoodRecovery = async () => {
    if (!this.accountsId) return;
    if (this.efrModel.selectedFoods.length > 0) {
      await Promise.all(this.efrModel.selectedFoods.map(async (id) => {
        this.updateReq = this.api.deleteFoodRecoveries({
          id: Number(this.accountsId),
          foodRecovery: {
            id: Number(id),
          },
        });
        await this.updateReq;
      }));
    }

    return this.updateReq;
  };

  @action deleteSelectedEFR = async () => {
    await this.deleteAssignFoodRecovery();
    await this.efrModel.fetchFoods();
    this.toggleDeleteModal(false);
  };
  @action addAssignFoodRecovery = async (data: ItemType) => {
    if (!this.accountsId) return;
    this.updateReq = this.api.updateAssignFoodGenerator({
      id: this.accountsId,
      foodRecovery: {
        id: data.id,
      },
    });

    await this.updateReq;
    await this.efrModel.fetchFoods();
    this.removeSelectedFoods();
  };

  @action setSelectedFoods = (items: GridRowId[]) => {
    this.efrModel.selectedFoods = items;
  };

  @action removeSelectedFoods = () => {
    if (this.efrModel.selectedFoods.length === 0) return;
    this.efrModel.selectedFoods = [];
  };

  @action toggleDeleteModal = (force: boolean) => {
    this.deleteFoodModal = force;
  };

  @action fetchInitData = async (accountId: number) => {

    this.setAccountId(accountId);

    try {
      await this.accountEFGStore.fetchDetails(accountId).then(async () => {
        if (this.accountEFGStore.isMarkedEFG) {
          await this.efrModel.filter.setPersistedFilters({ 'q.account.id': `${accountId}` });
          await this.efrModel.fetchFoods();
        }
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  @action creation = async (data: Partial<EfrDetailsType>) => {
    await this.efrModel.creationEFR({ ...data, accountId: this.accountsId });
    await this.efrModel.fetchFoods();
  };
}

export const { store: accountEFRStore, storeCtx: accountDetailsEFRStoreCtx } = storeFactory(
  AccountEFRStore,
  'accountEFRStore',
);
